import {
  deleteUploadedFiles,
  uploadFileToStorage,
} from "./fileStorage";

function resolveClearFiles(options) {
  if (Array.isArray(options?.value)) {
    return options.value;
  }

  if (Array.isArray(options?.fileValue)) {
    return options.fileValue;
  }

  if (options?.value && typeof options.value === "object") {
    return [options.value];
  }

  return [];
}

function renderFilePreviews(questionName, values) {
  setTimeout(() => {
    // Find container via file input id which uses the question name
    const fileInput = document.querySelector(`#file-input-${questionName}`);
    if (!fileInput) {
      console.log('file input not found for', questionName);
      return;
    }
    const container = fileInput.closest('div[class*="file-upload-container"]');
    if (!container) {
      console.log('container not found');
      return;
    }
    console.log('container found:', container);

    // Find or create preview area
    const parent = container.parentElement;
    if (!parent) return;

    let previewArea = parent.querySelector('.navriti-preview-area');

    if (!previewArea) {
      previewArea = document.createElement('div');
      previewArea.className = 'navriti-preview-area';
      previewArea.style.cssText = 'display:flex;flex-wrap:wrap;gap:16px;margin-top:12px;width:100%;';
      container.insertAdjacentElement('afterend', previewArea);
    }
    previewArea.style.cssText = 'display:flex;flex-wrap:wrap;gap:16px;margin-top:12px;width:100%;align-items:flex-start;';

    if (!Array.isArray(values) || values.length === 0) return;

    values.forEach((fileValue) => {
      const previewContent = fileValue?.content || fileValue?.path;
      const name = fileValue?.name || fileValue?.file?.name || '';
      console.log('processing file:', name, 'previewContent:', previewContent); 
      const isVideo = name.match(/\.(mp4|webm|ogg|mov)$/i);
      const isAudio = name.match(/\.(mp3|wav|ogg|aac)$/i);
      const isPdf = name.match(/\.pdf$/i);
      const isCsv = name.match(/\.csv$/i);
      const isDocx = name.match(/\.(doc|docx)$/i);
      const isXlsx = name.match(/\.(xls|xlsx)$/i);
      const isImage = name.match(/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i);
      console.log('isPdf:', isPdf, 'isImage:', isImage); 

      if (!previewContent) return;

      const wrapper = document.createElement('div');
      wrapper.style.cssText = 'width:calc(50% - 8px);box-sizing:border-box;border:1px solid #eee;border-radius:8px;overflow:hidden;';
      wrapper.setAttribute('data-preview-name', name);

      if (isImage) {
        const img = document.createElement('img');
        img.src = previewContent;
        img.style.cssText = 'width:100%;height:150px;object-fit:cover;display:block;';
        wrapper.appendChild(img);
      } else if (isVideo) {
        const mediaEl = document.createElement('video');
        mediaEl.src = previewContent;
        mediaEl.controls = true;
        mediaEl.style.cssText = 'width:100%;height:150px;object-fit:contain;display:block;';
        wrapper.appendChild(mediaEl);
      } else if (isAudio) {
        const mediaEl = document.createElement('audio');
        mediaEl.src = previewContent;
        mediaEl.controls = true;
        mediaEl.style.cssText = 'width:100%;margin-top:8px;';
        wrapper.appendChild(mediaEl);
      } else if (isPdf) {
        const iframe = document.createElement('iframe');
        iframe.src = previewContent + '#toolbar=0&navpanes=0&scrollbar=0';
        iframe.style.cssText = 'width:100%;height:200px;border:none;display:block;';
        wrapper.appendChild(iframe);
      } else if (isCsv || isDocx || isXlsx) {
        const icon = isCsv ? '📊' : isDocx ? '📝' : '📈';
        const label = isCsv ? 'CSV' : isDocx ? 'Word Document' : 'Excel Spreadsheet';
        wrapper.style.cssText += 'display:flex;flex-direction:column;align-items:center;justify-content:center;padding:16px;min-height:100px;';
        wrapper.innerHTML = `<div style="font-size:40px">${icon}</div><div style="font-size:12px;color:#666;margin-top:4px">${label}</div><div style="font-size:11px;color:#999;margin-top:2px;word-break:break-all;text-align:center">${name}</div>`;
      }
      console.log('wrapper hasChildNodes:', wrapper.hasChildNodes());

      if (wrapper.hasChildNodes()) {
        previewArea.appendChild(wrapper);
      }
    });
  }, 800);
}

export function bindSurveyFileHandlers(model, context) {
  model.onUploadFiles?.add(async (_, options) => {
    try {
      const uploadedFiles = await Promise.all(
        options.files.map((file) =>
          uploadFileToStorage({
            file,
            formId: context.formId,
            encryptedFormId: context.encryptedFormId,
            questionName: options.question?.name,
            token: context.token,
          })
        )
      );

      const result = options.files.map((originalFile, index) => {
        const blobUrl = URL.createObjectURL(originalFile);
        const s3Path = uploadedFiles[index].path;
        window.__blobUrlMap = window.__blobUrlMap || new Map();
        window.__blobUrlMap.set(blobUrl, s3Path);
        return {
          file: {
            name: uploadedFiles[index].name,
            type: uploadedFiles[index].type || "application/octet-stream",
          },
          content: blobUrl,
          path: s3Path,
        };
      });

      options.callback(result);
      if (options.question) {
        options.question.value = result;
      }
      const questionName = options.question?.name;
      const formJson = context.formJson;
      const allElements = (formJson?.pages || []).flatMap(p => p.elements || []);
      const questionDef = allElements.find(el => el.name === questionName);
      const isMultiple = questionDef?.allowMultiple === true;

      if (!isMultiple) {
        setTimeout(() => {
          const fileInput = document.querySelector(`#file-input-${questionName}`);
          if (fileInput) {
            const label = fileInput.nextElementSibling;
            if (label) {
              label.style.pointerEvents = 'none';
              label.style.opacity = '0.5';
              label.style.cursor = 'not-allowed';
            }
          }
        }, 300);
      }

      // Trigger file preview rendering after upload completes
      console.log('upload complete, triggering preview', options.question?.name, result);
      renderFilePreviews(options.question?.name, result);

    } catch (error) {
      console.error("Survey file upload failed:", error);
      options.callback([], [error.message || "File upload failed"]);
    }
  });

  model.onClearFiles?.add(async (_, options) => {
    try {
      const files = resolveClearFiles(options);
      if (files.length > 0) {
        await deleteUploadedFiles({
          files,
          formId: context.formId,
          encryptedFormId: context.encryptedFormId,
          token: context.token,
        });
      }
      options.callback("success");
      if (options.question) {
        options.question.value = undefined;
      }
      setTimeout(() => {
        const questionName = options.question?.name;
      if (!questionName) return;
      const fileInput = document.querySelector(`#file-input-${questionName}`);
      if (fileInput) {
        const label = fileInput.nextElementSibling;
        if (label) {
          label.style.pointerEvents = '';
          label.style.opacity = '';
          label.style.cursor = '';
        }
      }
    }, 300);
    } catch (error) {
      console.error("Survey file cleanup failed:", error);
      options.callback("error", error.message || "Failed to remove file");
    }
  });
  setTimeout(() => {
  const allFileInputs = document.querySelectorAll('input[type="file"][id^="file-input-"]');
  allFileInputs.forEach(fileInput => {
    const container = fileInput.closest('div[class*="file-upload-container"]');
    if (!container) return;

    const observer = new MutationObserver(() => {
      const fileItems = container.querySelectorAll('div[style*="align-items: center"][style*="justify-content: space-between"]');
      const previewArea = container.parentElement?.querySelector('.navriti-preview-area');
      const fileCount = fileItems.length;

      if (previewArea) {
        if (fileCount === 0) {
          previewArea.innerHTML = '';
          // Re-enable upload box
          const label = fileInput.nextElementSibling;
          if (label) {
            label.style.pointerEvents = '';
            label.style.opacity = '';
            label.style.cursor = '';
          }
        } else {
        // Get current file names from the file list
        const currentFileNames = Array.from(fileItems).map(item => {
          const nameEl = item.querySelector('span, div');
          return nameEl?.textContent?.trim();
        });

        // Remove previews whose file names are no longer in the list
        Array.from(previewArea.children).forEach(child => {
          const previewName = child.getAttribute('data-preview-name');
          if (previewName && !currentFileNames.some(n => n && previewName.includes(n.split('.')[0]))) {
            previewArea.removeChild(child);
          }
        });
      }
    }
  });

  observer.observe(container, { childList: true, subtree: true });
});
}, 1500);
}
export function applyFileSourceTypes(formJson) {
  setTimeout(() => {
    const pages = formJson?.pages || [];
    pages.forEach(page => {
      (page.elements || []).forEach(el => {
        if (el.type !== 'file') return;
        const sourceType = el.sourceType || 'file, camera';
        const fileInput = document.querySelector(`#file-input-${el.name}`);
        if (!fileInput) return;
        if (sourceType === 'camera') {
          fileInput.setAttribute('capture', 'environment');
          fileInput.removeAttribute('multiple');
        } else if (sourceType === 'file, camera') {
          fileInput.setAttribute('capture', 'environment');
        } else {
          fileInput.removeAttribute('capture');
        }
      });
    });
  }, 800);
}